import React from 'react';
import { LucideIcon } from 'lucide-react';

interface CtaButtonProps {
    label: string;
    icon?: string | React.ReactElement;
    onClick?: () => void;
}

export const CtaButton: React.FC<CtaButtonProps> = ({ label, icon, onClick }) => {
    return (
        <button
            className="h-[54px] flex gap-2 justify-center items-center px-6 text-xl font-semibold text-[#f5f5f5] bg-[#1A4D4F] rounded-lg hover:bg-[#1A4D4F]/90 transition-colors font-switzer"
            onClick={onClick}
        >
            {label}

            {/* Render different icon types */}
            {icon && (
                typeof icon === 'string' ? (
                    // Render image URL
                    <img loading="lazy" src={icon} alt="" className="w-6 aspect-square" />
                ) : (
                    // Render Lucide or other React component icon
                    React.cloneElement(icon, {
                        className: "w-6 h-6",
                        ...icon.props
                    })
                )
            )}
        </button>
    );
};